import {regexPatterns, validationRules, errorMessages} from './validationVariables';
import {isNullOrEmpty} from '../StringHelpers/StringHelpers';
export const validateInput = (inputVal: string, inputType: TextInputEnum, required: boolean = true) => {
  const inputValidation = InputValidation[inputType];
  const regex = new RegExp(inputValidation.regexPattern);
  let error: string = '';
  if (
    (inputValidation.minLength && inputVal.length < inputValidation.minLength && !isNullOrEmpty(inputVal)) ||
    (inputValidation.maxLength && inputVal.length > inputValidation.maxLength && !isNullOrEmpty(inputVal))
  ) {
    error = inputValidation.error.invalidInput;
    return error;
  }
  const match = inputVal ? regex.test(inputVal) : false;
  if (!match && !(!required && isNullOrEmpty(inputVal))) {
    error = isNullOrEmpty(inputVal) ? inputValidation.error.emptyInput : inputValidation.error.invalidInput;
  } else if (inputType == TextInputEnum.Id && !validateIsraeliID(inputVal)) {
    error = InputValidation.Id.error.identity;
  }
  return error;
};

export function validateIsraeliID(id: string) {
  //
  // Calculate the checksum
  let sum = 0;
  for (let i = 0; i < 9; i++) {
    let digit = parseInt(id[i], 10);
    let multiplied = digit * ((i % 2) + 1);
    sum += Math.floor(multiplied / 10) + (multiplied % 10);
  }

  // Validate the checksum
  return sum % 10 === 0;
}

export const enum TextInputEnum {
  FirstName = 'FirstName',
  LastName = 'LastName',
  HebrewFirstName = 'HebrewFirstName',
  HebrewLastName = 'HebrewLastName',
  Mail = 'Mail',
  Phone = 'Phone',
  PhoneExtended = 'PhoneExtended',
  Id = 'Id',
  String = 'String',
  Number = 'Number',
  bankAccountNo = 'bankAccountNo',
  Date = 'Date',
  Sim = 'Sim',
  None = 'None',
  SecurityCode = 'SecurityCode',
  IMEI = 'IMEI',
  CouponCode = 'CouponCode',
}

export const InputValidation: Record<
  TextInputEnum,
  {
    regexPattern: string;
    error: {
      emptyInput: string;
      invalidInput: string;
      identity?: string;
    };
    minLength?: number;
    maxLength?: number;
  }
> = {
  Mail: {
    regexPattern: regexPatterns.emailRegex,
    error: {
      emptyInput: validationRules.email.required.error,
      invalidInput: validationRules.email.minLength.error,
    },
  },
  Phone: {
    regexPattern: regexPatterns.phoneRegex,
    error: {
      emptyInput: validationRules.phone.required.error,
      invalidInput: validationRules.phone.minLength.error,
    },
  },
  PhoneExtended: {
    regexPattern: regexPatterns.PhoneExtendedRegex,
    error: {
      emptyInput: validationRules.PhoneExtended.required.error,
      invalidInput: validationRules.PhoneExtended.minLength.error,
    },
  },
  Id: {
    regexPattern: regexPatterns.identityRegex,
    error: {
      emptyInput: validationRules.id.required.error,
      invalidInput: validationRules.id.minLength.error,
      identity: validationRules.id.identity.error,
    },
  },
  FirstName: {
    regexPattern: regexPatterns.lettersAndSymbolsOnly,
    error: {
      emptyInput: 'אנה הכנס שם פרטי',
      invalidInput: errorMessages.onlyLetters,
    },
  },
  LastName: {
    regexPattern: regexPatterns.lettersAndSymbolsOnly,
    error: {
      emptyInput: 'אנה הכנס שם משפחה',
      invalidInput: errorMessages.onlyLetters,
    },
  },
  HebrewFirstName: {
    regexPattern: validationRules.onlyHebrewLetter.pattern.value,
    error: {
      emptyInput: 'אנה הכנס שם פרטי',
      invalidInput: validationRules.onlyHebrewLetter.pattern.error,
    },
  },
  HebrewLastName: {
    regexPattern: validationRules.onlyHebrewLetter.pattern.value,
    error: {
      emptyInput: 'אנה הכנס שם משפחה',
      invalidInput: validationRules.onlyHebrewLetter.pattern.error,
    },
  },
  bankAccountNo: {
    regexPattern: regexPatterns.numbersRegex,
    error: {
      emptyInput: ' אנא  הכנס מספר חשבון',
      invalidInput: errorMessages.onlyNumbers,
    },
  },
  String: {
    regexPattern: regexPatterns.lettersOnlyRegex,
    error: {
      emptyInput: 'שדה חובה',
      invalidInput: errorMessages.onlyLetters,
    },
  },
  Number: {
    regexPattern: regexPatterns.numbersRegex,
    error: {
      emptyInput: 'שדה חובה',
      invalidInput: errorMessages.onlyNumbers,
    },
  },
  Sim: {
    regexPattern: regexPatterns.simRegex,
    error: {
      emptyInput: 'שדה חובה',
      invalidInput: 'המספר שהקלדת לא תקין. מזכירים שצריך את 18 הספרות',
    },
  },
  Date: {
    regexPattern: regexPatterns.dateRegex,
    error: {
      emptyInput: 'אנה בחר תאריך',
      invalidInput: 'אנה הכנס תאריך תקין',
    },
  },
  None: {
    regexPattern: '',
    error: {
      emptyInput: 'שדה חובה',
      invalidInput: '',
    },
  },
  SecurityCode: {
    regexPattern: '^[0-9]{1,9}$',
    error: {
      emptyInput: 'יש להזין קוד',
      invalidInput: 'יש להזין קוד תקין',
    },
  },
  IMEI: {
    regexPattern: regexPatterns.numbersRegex,
    minLength: 15,
    maxLength: 15,
    error: {
      emptyInput: 'חובה להזין ערך בעל 15 ספרות',
      invalidInput: 'חובה להזין ערך בעל 15 ספרות',
    },
  },
  CouponCode: {
    regexPattern: regexPatterns.lettersNumbersOnlyRegex,
    error: {
      emptyInput: 'יש להזין קוד קופון',
      invalidInput: errorMessages.onlyLettersAndNumbers,
    },
  },
};
